module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_6000.6de71765.png";